if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * FormSubmit
         * Events: change, click etc
         */
        ZZ.FormSubmit = function(container) {
            var base = this;
            base._container = container;
            base._triggerEvent = base._container.attr("data-formsubmit-event");
            base._novalidation = base._container.attr(
                "data-formsubmit-removevalidation"
            );
            base._FormToTrigger = base._container.closest("form");
            //
            base.assignListeners();
        };

        ZZ.FormSubmit.prototype = {
            assignListeners: function() {
                var base = this;

                base._container.bind(base._triggerEvent, function() {
                    if (base._novalidation && base._novalidation === "true") {
                        base._FormToTrigger.off("submit");
                    }
                    base._FormToTrigger.submit();
                });
            }
        };
    })(jQuery);
}
